import React, { useState, useEffect } from "react";

import { DashboardLayout } from "../components/layout";

import Icon from "../components/common/Icon";

import api from "../services/api";

import { useAuth } from "../context/AuthContext";

import { Crown, Lock } from "lucide-react";

import CreatePostModal from "../components/post/CreatePostModal";

const GreenCheck = () => (
<svg width="22" height="22" viewBox="0 0 24 24" className="flex-shrink-0">
<circle cx="12" cy="12" r="10" fill="#fff" />
<path

      d="m9 12 2 2 4-4"

      stroke="black"

      strokeWidth="2.5"

      fill="none"

      strokeLinecap="round"

      strokeLinejoin="round"

    />
</svg>

);

const GoldCheck = ({ filled }) => (
<svg width="27" height="27" viewBox="0 0 24 24" className="flex-shrink-0">
<circle

      cx="12"

      cy="12"

      r="10"

      fill={filled ? "#FEDC5A" : "none"}

      stroke={filled ? "#FEDC5A" : "#D1D5DB"}

      strokeWidth="2"

    />
<path

      d="m9 12 2 2 4-4"

      stroke={filled ? "white" : "#D1D5DB"}

      strokeWidth="2"

      fill="none"

      strokeLinecap="round"

      strokeLinejoin="round"

    />
</svg>

);

const PilgrimMembershipPage = () => {

  const { user, fetchUser } = useAuth();

  const [plans, setPlans] = useState([]);

  const [mySub, setMySub] = useState(null);

  const [loading, setLoading] = useState(true);

  const [subscribing, setSubscribing] = useState(null);

  const [message, setMessage] = useState("");

  const [showCreate, setShowCreate] = useState(false);

  useEffect(() => {

    const load = async () => {

      try {

        const [p, s] = await Promise.all([

          api.getPlans(),

          api.getMySubscription(),

        ]);

        setPlans(p.plans || []);

        setMySub(s.subscription);

      } catch {

      } finally {

        setLoading(false);

      }

    };

    load();

  }, []);

  useEffect(() => {

    const params = new URLSearchParams(window.location.search);

    const sessionId = params.get("session_id");

    if (!sessionId) return;

    const verify = async () => {

      try {

        const d = await api.request(

          `/plans/verify-session?session_id=${sessionId}`

        );

        setMessage(d.message || "Subscription activated!");

        const s = await api.getMySubscription();

        setMySub(s.subscription);

        await fetchUser();

        window.history.replaceState({}, "", "/pilgrim-membership");

      } catch (e) {

        setMessage(e.error || "Verification failed");

      }

    };

    verify();

  }, [fetchUser]);

  const handleSubscribe = async (planId) => {

    setSubscribing(planId);

    setMessage("");

    try {

      const d = await api.subscribe(planId);

      if (d.checkoutUrl) {

        window.location.href = d.checkoutUrl;

      } else {

        setMessage(d.message || "Subscription activated!");

        setMySub(d.subscription);

        await fetchUser();

      }

    } catch (e) {

      setMessage(e.error || "Subscription failed");

    } finally {

      setSubscribing(null);

    }

  };

  const freePlan = plans.find((p) => parseFloat(p.price) === 0);

  const paidPlan = plans.find((p) => parseFloat(p.price) > 0);

  const allFeatures = new Set();

  plans.forEach((p) => {

    (Array.isArray(p.features) ? p.features : []).forEach((f) =>

      allFeatures.add(f)

    );

  });

  const comparisonRows = Array.from(allFeatures).map((f) => ({

    name: f,

    free: freePlan?.features?.includes(f) || false,

    pilgrim: paidPlan?.features?.includes(f) || false,

  }));

  if (loading)

    return (
<DashboardLayout onCreatePost={() => setShowCreate(true)}>
<div className="flex-1 flex items-center justify-center">
<div className="w-8 h-8 border-3 border-primary border-t-transparent rounded-full animate-spin" />
</div>
</DashboardLayout>

    );

  return (
<DashboardLayout onCreatePost={() => setShowCreate(true)}>
<div

        className="flex-1 min-w-0 py-4 sm:py-6 px-4 sm:px-8 md:px-12 lg:px-[20px] 2xl:px-[80px] overflow-y-auto"

        style={{

          maxHeight: "calc(100vh - 56px)",

          scrollbarWidth: "none",

          msOverflowStyle: "none",

        }}
>
<div className="text-center mb-6 sm:mb-8">
<h1 className="text-[24px] sm:text-[30px] md:text-[40px] lg:text-[45.56px] font-black text-[#000000] font-display">

            Find Your Perfect Plan
</h1>
<p className="text-[13px] sm:text-[15px] md:text-[17.09px] text-[#797878] max-w-[562px] mx-auto leading-relaxed font-body">

            Discover the ideal plan to fuel your business growth. Our pricing

            options are carefully crafted to cater to businesses.
</p>
</div>

        {message && (
<div className="mb-6 p-3 sm:p-4 bg-green-50 border border-green-200 rounded-xl text-[13px] sm:text-[14px] text-green-700 text-center">

            {message}
</div>

        )}
<div className="flex flex-col gap-4 sm:gap-6 mb-8 sm:mb-10">

          {plans.map((plan) => {

            const isActive = mySub?.planSlug === plan.slug;

            const features = Array.isArray(plan.features) ? plan.features : [];

            return (
<div

                key={plan.id}

                className="rounded-[24.64px] overflow-hidden"

                style={{

                  background:

                    "linear-gradient(137.47deg, #1F3A5F 11.08%, #567294 42.04%, #2C5282 95.9%)",

                }}
>
<div className="flex flex-col sm:flex-row">

                  {/* Left info section */}
<div className="p-5 sm:p-6 md:p-8 lg:pl-16 xl:pl-20 flex flex-col justify-center text-white flex-1">
<div className="inline-flex items-center gap-2 bg-[#FFFFFF1A] rounded-full px-3 sm:px-4 py-1.5 mb-4 sm:mb-5 text-[#FEDC5A] w-fit">
<Crown size={18} />
<span className="text-[11px] sm:text-[13.13px] font-medium">

                        {plan.name}
</span>
</div>
<h2 className="text-[18px] sm:text-[22px] md:text-[28px] lg:text-[30px] font-bold mb-2 sm:mb-3 font-body">

                      {plan.tagline || "Deepen Your Spiritual Journey"}
</h2>
<p className="text-white text-[12px] sm:text-[14px] md:text-[15px] mb-4 sm:mb-6 max-w-full sm:max-w-[75%] font-medium leading-relaxed font-body">

                      {plan.description}
</p>
<div className="flex items-baseline gap-1 mb-4 sm:mb-6">
<span className="text-[32px] sm:text-[40px] md:text-[48px] lg:text-[51.94px] font-medium leading-none">

                        ${parseFloat(plan.price).toFixed(0)}
</span>
<span className="text-[13px] sm:text-[16px] md:text-[20.78px] text-[#F6F7F8] font-light">

                        per {plan.billing_interval}
</span>
</div>
<button

                      onClick={() => handleSubscribe(plan.id)}

                      disabled={isActive || subscribing === plan.id || plan.slug=='free'}

                      className={`w-full max-w-full sm:max-w-[400px] py-3 rounded-[10.39px] text-[14px] sm:text-[16px] md:text-[20.78px] transition-all ${

                        isActive ||  plan.slug=='free'

                          ? "bg-gray-400 cursor-not-allowed text-white"

                          : "bg-[#1F3A5F] hover:brightness-110 text-white"

                      } disabled:opacity-70`}
>

                      {isActive

                        ? "Current Plan"

                        : subscribing === plan.id

                        ? "Processing..."

                        : parseFloat(plan.price) === 0

                        ? "Free Plan"

                        : "Become a Pilgrim"}
</button>
</div>

                  {/* Right features section */}

                  {features.length > 0 && (
<div className="p-5 sm:p-6 md:py-8 flex flex-col justify-center border-t sm:border-t-0 sm:border-l border-white/10 sm:min-w-[240px] md:min-w-[280px]">
<p className="text-white text-[13px] sm:text-[15px] md:text-[16.35px] mb-3 sm:mb-5">

                        What's Included:
</p>
<div className="flex flex-col gap-2 sm:gap-3">

                        {features.map((f, i) => (
<div key={i} className="flex items-center gap-2 sm:gap-3">
<GreenCheck />
<span className="text-[#F6F7F8] text-[12px] sm:text-[14px] md:text-[16px] lg:text-lg">

                              {f}
</span>
</div>

                        ))}
</div>
</div>

                  )}
</div>
</div>

            );

          })}
</div>

        {comparisonRows.length > 0 && (
<>
<h2 className="text-[18px] sm:text-[22px] md:text-[28px] font-bold text-[#0F1D2E] mb-3 sm:mb-4 font-body">

              FREE VS PILGRIM
</h2>
<div className="bg-white rounded-[8.15px] overflow-x-auto">
<table className="w-full min-w-[360px]">
<thead>
<tr className="border-b border-[#DDDDDD]">
<th className="text-left border-r border-[#DDDDDD] px-4 sm:px-8 md:px-10 py-3 sm:py-4 text-[13px] sm:text-[17px] md:text-[21.73px] font-medium font-body text-[#000000]">

                      Features
</th>
<th className="px-3 sm:px-4 border-r border-[#DDDDDD] py-3 sm:py-4 text-[13px] sm:text-[17px] md:text-[21.73px] font-medium font-body text-[#000000] w-16 sm:w-20 md:w-24 text-center">

                      Free
</th>
<th className="text-center px-3 sm:px-4 py-3 sm:py-4 text-[13px] sm:text-[17px] md:text-[21.73px] font-medium font-body text-[#000000] w-16 sm:w-20 md:w-24">

                      Pilgrim
</th>
</tr>
</thead>
<tbody>

                  {comparisonRows.map((row, i) => (
<tr key={i}>
<td

                        className={`px-4 sm:px-8 md:px-10 ${i % 2 && "bg-[#f8f9fa]"} border-r border-[#DDDDDD] py-2.5 sm:py-3 font-body text-[11px] sm:text-[14px] md:text-[18px] text-[#777777]`}
>

                        {row.name}
</td>
<td

                        className={`text-center ${i % 2 && "bg-[#f8f9fa]"} border-r border-[#DDDDDD]`}
>
<div className="flex justify-center items-center py-3 sm:py-4">

                          {row.free ? (
<GoldCheck filled />

                          ) : (
<Lock className="text-[#777777]" size={22} />

                          )}
</div>
</td>
<td

                        className={`text-center ${i % 2 && "bg-[#f8f9fa]"}`}
>
<div className="flex justify-center items-center py-3 sm:py-4">

                          {row.pilgrim ? (
<GoldCheck filled />

                          ) : (
<Lock className="text-[#777777]" size={22} />

                          )}
</div>
</td>
</tr>

                  ))}
</tbody>
</table>
</div>
</>

        )}
</div>
<CreatePostModal isOpen={showCreate} onClose={() => setShowCreate(false)} />
</DashboardLayout>

  );

};

export default PilgrimMembershipPage;

 